import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Checker',
  props: {
  title: { type: String },
  value: { type: Boolean }
},
  emits: ['check'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit
const value = ref('')

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
    emit("activate", value);
  },
});

const __returned__ = { props, emit, value, model, ref, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})